<template>
	<div>
		<ul>

			<table class="table table-compact smaller text-faded mb-0">
				<thead>
				<tr>
					<th>
						{{ t.finance.currency }}
					</th>
					<th class="text-right">
						{{ t.total }}
					</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="d in data" v-if="d.curr">
					<td>
						<span>{{ d.curr.iso_code }} {{ d.curr.symbol }}</span>
					</td>
					<td class="text-right text-bright">
						<a href="javascript:void" v-on:click="changeCurrency(d.curr)">
							{{ d.total_amount | toMoney(d.curr) }}
						</a>
					</td>
					<td class="text-right text-danger" :class="(getPercentageChange(d.total_amount_last_15m, d.total_amount)) > 0 ? 'text-success' : 'text-danger' ">
						{{ getPercentageChange(d.total_amount_last_15m, d.total_amount).toFixed(2) }}%
					</td>
				</tr>
				</tbody>
			</table>
		</ul>
	</div>
</template>

<script>
    import formatter from '@/mixins/formatter'
    export default {
        name: 'currencyWidget',
        mixins: [formatter],
	    props: {
            filter: {
				default: {},
	            required: false
            }
	    },
	    watch: {
            filter: function(newVal, oldVal) { // watch it
                this.getCurrencyAnalytics();
            }
	    },
        data () {
            return {
                t: this.$root.t,
                data: null,
	            isLoading: false,
	            status: 0
            }
        },
	    mounted () {
          this.getCurrencyAnalytics();
	    },
	    methods: {
            changeCurrency (c) {

                this.$bus.$emit('changeCurrencyAnalytics', c)
            },
            getCurrencyAnalytics () {
                this.$http.get(api+'api/v1/analytics/general/currency/stats', { params: this.filter }).then(
                    response => {
                    // get body data
                    this.isLoading = false;
                    this.status = response.status;
                    this.data = response.body.result.stats;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;
             })

            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul,li {
	list-style: none;
	padding: 0
}
</style>



// WEBPACK FOOTER //
// src/components/accounting/widget/currency.vue